<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="contactForm" :MediaListRef="MediaListRef">
        <template v-slot:PageBody>
          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_Contact_GeneralContactInfo')">
              <!-- <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_CompanyInfo_Contact_GeneralContactInfo_Blue_p')">
                </div>
              </template> -->
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t('lbl_EMPBE_CompanyInfo_Basic_Headquarter') }} <span class="text-danger">*</span>
                  </div>
                </div>
                <div class="col-12">
                  <selection ControlId="countryId" :title="$t('lbl_EMPBE_PleaseSelect')"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_Headquarter') + $t('lbl_IsRequire')"
                    v-model="form.generalContactInfo.countryId" label="text" 
                    :options="SelectOptions.CountryOptions">
                  </selection>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t("lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_En") }} <span class="text-danger">*</span>
                  </div>
                  <div class="Input_Label_Right"><span class="text-danger">*</span>&nbsp;{{$t('lbl_EMPBE_CompanyInfo_Basic_Required')}}</div>
                </div>
                <div class="col-12">
                  <textbox ControlId="addressEng1" v-model="form.generalContactInfo.addressEng1"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_Flat_PlaceOther_En')"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Contact_Flat_PlaceOther_En') + $t('lbl_IsRequire')"
                    type="text">
                  </textbox>
                </div>
                <div class="col-12">
                  <textbox ControlId="addressEng2" v-model="form.generalContactInfo.addressEng2"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_Building_PlaceOther_En')"
                    type="text">
                  </textbox>
                </div>
                <div class="col-12">
                  <textbox ControlId="addressEng3" v-model="form.generalContactInfo.addressEng3"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_City_PlaceOther_En')"                  
                    type="text">
                  </textbox>
                  <CompanyFieldApprovalResults usage-type="companyAddressE" />
                </div>
                <div class="col-12">
                  <textbox ControlId="postalCode" type="number" v-model="form.generalContactInfo.postalCode"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_PostalCode')">
                  </textbox>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t("lbl_EMPBE_CompanyInfo_Contact_CompanyAddress_Cn") }}
                  </div>
                  <div class="Input_Label_Right"></div>
                </div>
                <div class="col-12">
                  <textbox ControlId="addressTC1" v-model="form.generalContactInfo.addressTC1"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_Flat_PlaceOther_Cn')" type="text">
                  </textbox>
                </div>
                <div class="col-12">
                  <textbox ControlId="addressTC2" v-model="form.generalContactInfo.addressTC2"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_Building_PlaceOther_Cn')" type="text">
                  </textbox>
                </div>
                <div class="col-12">
                  <textbox ControlId="addressTC3" v-model="form.generalContactInfo.addressTC3"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_City_PlaceOther_Cn')" type="text">
                  </textbox>
                  <CompanyFieldApprovalResults usage-type="companyAddressS" />
                </div>
              </div>
              <div class="row" v-if="AplusABCBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    <TipsAndPrivewDilog :id="'EMPBE_Comp_Banner_HeadquarterPhoto_Info'"
                      :Title="$t('lbl_EMPBE_CompanyInfo_Contact_HeadquarterPhoto_Tips')">
                      <template v-slot:Text>
                        {{ $t("lbl_EMPBE_CompanyInfo_Contact_HeadquarterPhoto") }} <span class="text-danger">*</span>
                      </template>
                    </TipsAndPrivewDilog>
                  </div>
                  <div class="Input_Label_Right"></div>
                </div>
                <div class="col-12 CompanyHeadquarter_ImgUpload"
                  v-html="$t('lbl_EMPBE_CompanyInfo_Contact_HeadquarterPhoto_P')">
                </div>
                <div class="col-12">
                  <MediaApprovalGallery
                    v-if="shouldShowMediaApprovalGallery(HeadquarterPhoto)"
                    :MediaArray="HeadquarterPhoto"
                    mode="admin"
                    media-type="image"
                    gallery-item-style="width: 164px; height: 100px;"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_HeadquarterPhoto')"
                    :approval-content-results="getMediaApprovalResults('CompanyHeadquarter')"
                    :approval-content-result-drafts="getMediaApprovalDraftMap('CompanyHeadquarter', HeadquarterPhoto)"
                    :rejection-templates="mediaApprovalRejectionTemplates"
                    :rejection-actor="mediaApprovalRejectionActor"
                    @approval-draft-change="onMediaApprovalDraftChange('CompanyHeadquarter', $event)"
                  />
                  <template v-else>
                    <mediaUploader
                      :MediaArray="HeadquarterPhoto"
                      ref="HeadquarterPhoto"
                      :isRequired="true"
                      :isDisabled="isApprovalMediaReadOnly"
                      aspectRatioStr="10:6"
                      galleryItemStyle="width: 164px; height: 100px;"
                      :limit="1"
                      :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                      fileUsageType="HeadquarterPhoto"
                      filePathEndpoint="Image"
                      :reject-records="getMediaRejectRecords('CompanyHeadquarter', HeadquarterPhoto, 'image')"
                      @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'HeadquarterPhoto')">
                    </mediaUploader>
                    <MediaRejectBanner :records="getMediaRejectRecords('CompanyHeadquarter', HeadquarterPhoto, 'image')" />
                  </template>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t("lbl_EMPBE_CompanyInfo_Contact_CompanyTelephone") }}
                  </div>
                  <div class="Input_Label_Right"></div>
                </div>
                <div class="col-6">
                  <selection ControlId="companyTelCountryCode" :title="$t('lbl_EMPBE_CompanyInfo_Contact_RegionCode')"
                    label="Name" v-model="form.generalContactInfo.companyTelCountryCode"
                    :options="SelectOptions.CellCountryOptions" :multiple="false" :preselect-first="true"></selection>
                </div>
                <div class="col-6">

                  <textbox type="number" ControlId="conpanyTelArea" v-model="form.generalContactInfo.conpanyTelArea"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_AreaCode')">
                  </textbox>
                </div>
                <div class="col-6">
                  <textbox ControlId="conpanyTelNumber" type="text" v-model="form.generalContactInfo.conpanyTelNumber"
                    :title="$t('lbl_EMPBE_CompanyInfo_Contact_CompanyTelNumber')">
                  </textbox>
                </div>
                <div class="col-6">
                  <textbox ControlId="CompanyTel_TelExtension" type="number"
                    v-model="form.generalContactInfo.conpanyTelExt" :title="$t('lbl_EMPBE_CompanyInfo_Contact_Ext')">
                  </textbox>
                </div>
                <div class="col-12">
                  <CompanyFieldApprovalResults usage-type="companyTel" />
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_Contact_SalesEnquiryContactInfo')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_CompanyInfo_Contact_SalesEnquiryContactInfo_Blue_p')">
                </div>
              </template>
            </BasicPageTop>

            <div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t("lbl_EMPBE_CompanyInfo_Contact_Title") }}
                  </div>
                  <div class="Input_Label_Right"><span class="text-danger">*</span>&nbsp;{{
                    $t('lbl_EMPBE_CompanyInfo_Basic_Required')}}</div>
                </div>
                <div class="col-12">
                  {{ $t("lbl_EMPBE_CompanyInfo_Contact_Title_P") }}
                </div>
              </div>
              <SalesEnquiryContactInfo :nums="2" v-model="form.salesEnquiryContactInfo"
                :CellCountryOptions="SelectOptions.CellCountryOptions"></SalesEnquiryContactInfo>
            </div>
          </div> -->

        </template>
      </PageValidate>
      <div class="CenterCard">
        <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_Contact_OtherContactInfo')">
          <!-- <template v-slot:Body>
            <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_CompanyInfo_Contact_OtherContactInfo_Blue_p',{href:GetOtherContactInfo})">
            </div>
          </template> -->
        </BasicPageTop>
        <div>
          <div class="row">
            <div class="col-12 mb-2 Input_Label">
              <div class="Input_Label_Left">
                {{ $t("lbl_EMPBE_CompanyInfo_Contact_OtherContactInfo_OtherOffices") }}
              </div>
            </div>
          </div>
          <OthersContactAndEnquiry ref="OthersContactAndEnquiry" :supplierId="supplierId"
            v-model="form.otherContactInfo" :CellCountryOptions="SelectOptions.CellCountryOptions"
            :NatureOptions="SelectOptions.NatureOptions" :nums="100" :CountryOptions="SelectOptions.CountryOptions">
          </OthersContactAndEnquiry>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { CompanyInfoService, fileUploadService } from "../../_services";
import { LogService } from "../../_services/log.Service";
import BasicPageTop from "./Popup/BasicPageTop.vue"
import SalesEnquiryContactInfo from "./Popup/SalesEnquiryContactInfo.vue"
import OthersContactAndEnquiry from "./Popup/OthersContactAndEnquiry.vue"
import MediaUploader from "../../components/form/upload/imgUploader/mediaUploader.vue"
import MediaRejectBanner from "../../components/form/upload/imgUploader/mediaRejectBanner.vue";
import MediaApprovalGallery from "../../components/form/upload/imgUploader/mediaApprovalGallery.vue";
import mediaApprovalGalleryBridge from "../../components/form/upload/imgUploader/mediaApprovalGalleryBridge.js";
import { getUpdateOSSUrlToDbRequest } from '@/_helpers/utility.js';
import { getInitImageDataObj } from '@/_helpers/media-uploader-utils.js';
import CompanyFieldApprovalResults from './CompanyFieldApprovalResults.vue';

export default {
  mixins: [mediaApprovalGalleryBridge],
  components: {
    BasicPageTop,
    SalesEnquiryContactInfo,
    OthersContactAndEnquiry,
    MediaUploader,
    MediaRejectBanner,
    MediaApprovalGallery,
    CompanyFieldApprovalResults,
  },
  inject: {
    permissionData: { default: null },
    companyApprovalHost: { default: null },
  },
  props: ["supplierId", "SelectOptions", "submitType"],
  data() {
    return {
      //Dirty
      loading: false,
      IsCreated:false,
      dirty: false,
      form: {
        generalContactInfo:
        {
          empCompanyId:"",
          addressEng1: "",
          addressEng2: "",
          addressEng3: "",
          addressTC1: "",
          addressTC2: "",
          addressTC3: "",
          postalCode: "",
          countryId: "",
          companyTelCountry: "",
          companyTelCountryCode: "",
          conpanyTelArea: "",
          conpanyTelNumber: "",
          conpanyTelExt: ""
        },
        salesEnquiryContactInfo: [],
        otherContactInfo: [],
        mediaFiles: [],
      },
      UploadedList: {
        HeadquarterPhoto: [],
      },
      pendingUploadFiles: {
        HeadquarterPhoto: [],
      },
      dbUpdateCommands: {
        HeadquarterPhoto: [],
      },
      MediaListRef: [
        "HeadquarterPhoto"
      ],
    };
  },
  computed: {
    useFormalTables() {
      const host = this.companyApprovalHost;
      return !!(host && host.fromAdmin && host.isApprovalMode);
    },
    HeadquarterPhoto() {
      return this.UploadedList.HeadquarterPhoto;
    },
    GetOtherContactInfo(){
      return this.GetEboothView();
    },  
    AplusABCBooth() {
      if (this.permissionData) {
        return ["A+","A", "B", "C"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    user() {
      return this.$store.state.authentication.user;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    PhotoType() {
      return [
        "HeadquarterPhoto"
      ];
    }
  },
  watch: {
    form: {
      handler() {
        if(!this.IsCreated)
        {
          this.dirty = true;
          this.$store.state.dirty = this.dirty;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.InitData();
  },
  methods: {
    // [BLK] Only update the stored data arrays for later manipulation
    handlerUploaderUpdateData(commands, pendingFiles, uploaderType) {
      this.dbUpdateCommands[uploaderType] = [...commands];
      this.pendingUploadFiles[uploaderType] = [...pendingFiles];
      // 图片/视频变更不走 form watch，需手动标 dirty，否则切 Tab 不会自动保存
      if (!this.IsCreated) {
        this.dirty = true;
        this.$store.state.dirty = true;
      }
    },

    resetFilePendingUpdate() {
      for (const prop in this.dbUpdateCommands) {
        this.$set(this.dbUpdateCommands, prop, []);
      }

      for (const prop in this.pendingUploadFiles) {
        this.$set(this.pendingUploadFiles, prop, []);
      }

      for (const key in this.UploadedList) {
        this.$set(this.UploadedList, key, []);
      }
    },

    InitData() {
      this.GetData();
      this.resetFormVerify();
      setTimeout(() => {
        this.dirty = false;
        this.$store.state.dirty = this.dirty;
      }, 200);
    },
    GetData() {
      this.loading = true;
      this.IsCreated=true;
      this.resetFilePendingUpdate();

      CompanyInfoService.GetContactAndEnquiry(this.supplierId, this.useFormalTables).then(res => {
        console.log(res);
        if (res.isSuccessful) {
          var result = res.data;
          this.form.generalContactInfo = result.generalContactInfo ?? this.form.generalContactInfo;
          //结构请对应  Popup/SalesEnquiryContactInfo
          this.form.salesEnquiryContactInfo = result.salesEnquiryContactInfo
            .map(item => {
              return {
                ...item,
                smsBtnStatus: false,
                emailBtnStatus: false,
                smstext: this.$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Verify'),
                emailtext: this.$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Verify'),
                smsCode: "",
                emailCode: "",
                isValidEmail: false,
                smsdisabled: false,
                emaildisabled: false,
                smsguid: "",
                emailguid: "",
              }
            });
          //结构请对应  Popup/OthersContactAndEnquiry
          this.form.otherContactInfo = result.otherContactInfo.filter(item => {
            return item.countryId || item.nameE || item.addressEng1 || item.nature || item.nameT || item.addressTc1;
          }).map(item => {
            return {
              ...item,
            }
          });

          // 获取图片 -> 填入 UploadList.mediaFile
          const mediaFile = result.mediaFile;
          this.form.mediaFiles = [mediaFile] ?? [];

          if (mediaFile) {
            this.$nextTick(() => {
              const id = mediaFile.rid;
              const cdnLink = mediaFile.fileName;
              const orderId = mediaFile.orderId;
              const usageType = mediaFile.usageType;

              const foundPhotoType = this.PhotoType.find((item) => item.toLowerCase() === usageType.toLowerCase());
              if (foundPhotoType) {
                this.UploadedList[foundPhotoType].push(getInitImageDataObj(mediaFile, { id, cdnLink, orderId, foundPhotoType }));
              }
            });
          }
        }
        setTimeout(() => {
              this.IsCreated = false;
        }, 500);
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    GetEboothView(){
        var  Companies = [];
        if(this.permissionData && this.permissionData?.Type != "Guest")
        {
          Companies = this.SelectOptions.EboothSample.filter(company => company.Grade === this.permissionData["Type"]);
        }
        else//Free
        {
          //
          Companies =  this.SelectOptions.EboothSample.filter(company => company.Grade === "Free");
        }
        const randomIndex = Math.floor(Math.random() * Companies.length);
        const randomCompany = Companies[randomIndex];

        return  randomCompany?.companyUrl;
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.contactForm.reset();
    },

    fileUploadHandle(isSubmit) {
      const pendingFiles = [];
      const commands = [];

      for (const key in this.pendingUploadFiles) {
        pendingFiles.push(...this.pendingUploadFiles[key]);
      }

      for (const key in this.dbUpdateCommands) {
        commands.push(...this.dbUpdateCommands[key]);
      }

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands,
        getFailedText: {
          "HeadquarterPhoto": this.$t("lbl_EMPBE_HeadquarterPhoto"),
        },
        uploadFinishCallback: (failedFilesFields) => this.$emit("uploadFinish", failedFilesFields)
      });
    },
    //整理結果提交save
    async AfterSaveResult(isSubmit) {
      const data = {
        generalContactInfo: {},
        salesEnquiryContactInfo: [],
        otherContactInfo: [],
        VaildError: [],
        validationErrorLog: "",
      };

      try {
        const uploadRes = await this.fileUploadHandle(isSubmit);

        try {
          await this.SaveFileUrlToDB(getUpdateOSSUrlToDbRequest(uploadRes));
        } catch (err) {
          console.error("UpdateOssUrlToDb failed:", err);
          const msg = err && err.message ? err.message : "Save OSS URL To DB Failed";
          data.validationErrorLog += (data.validationErrorLog ? "; " : "") + msg;
        }
      } catch (error) {
        const errorMessage = error && error.message ? error.message : (typeof error === "string" ? error : "文件上传失败，请重试");
        data.validationErrorLog += (data.validationErrorLog ? "; " : "") + errorMessage;
      }

      data.generalContactInfo = this.form.generalContactInfo;
      data.generalContactInfo.empCompanyId = this.supplierId;
      data.salesEnquiryContactInfo = this.form.salesEnquiryContactInfo;
      data.otherContactInfo = this.form.otherContactInfo;
      // console.log("数据", data);
      return data;
    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "SourcingRequestContact",
        Action: action,
      }, errorLogObj);
    },

    async SaveFileUrlToDB(uploadData) {
      try {
        const request = {
          ...uploadData,
          EmpCompanyId: this.supplierId,
          EmpProductId: 0
        };

        await fileUploadService.UpdateOssUrlToDb(request);
      } catch (err) {
        this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'UpdateOssUrlToDb');
        throw err;
      }
    },

    async Save() {
      var data = await this.AfterSaveResult(false);
      //写日志
      const query = {
        FormId: this.supplierId,
        Action: 'Before_Save',
        FormType: 'Company_Contact',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveContactAndEnquiry(data).then(res => {
          if (res.isSuccessful) {
            this.InitData();
            resolve({
              isSuccessful: true,
              popupAlertMsg: this.$t("lbl_EMPBE_SubmitAlert_SaveSuccessMessage"),
            });
          } else {
            this.LogPageFormError({ res: res }, "Save_SaveContactAndEnquiry");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, "Save_SaveContactAndEnquiry");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }),
            error: err,
          });
        })
      });
    },
    //提交
    async Submit() {
      if (process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() != "ai") {
        const otherRef = this.$refs.OthersContactAndEnquiry;
        const invalidIndex = (this.form.otherContactInfo || []).findIndex(
          (item) => otherRef && !otherRef.isContactItemComplete(item)
        );
        if (invalidIndex >= 0) {
          // this.$Alert(0, this.$t("lbl_EMPBE_Please_mandatory_And_exceptions_Tips"));
          otherRef.OpenContact(invalidIndex);
          return Promise.resolve({
            isSuccessful: true,
            isAllMandatoryFieldFilled: false,
          });
        }
      }

      var data = await this.AfterSaveResult(true);

      const query = {
        FormId: this.supplierId,
        Action: 'Before_Submit',
        FormType: 'Company_Contact',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveContactAndEnquiry(data).then(result => {
          if (result.isSuccessful) {
            this.$refs.contactForm
              .validate(true)
              .then(async (res) => {
                //写日志
                data.VaildError = res.fIldData;

                if (process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() == 'ai' || res.valid) {
                  this.InitData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: true,
                  });
                } else {
                  this.GetData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: false,
                  });
                }
              });
          } else {
            this.LogPageFormError({ result: result }, "Submit_SaveContactAndEnquiry");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode", { code: result.statusCode, msg: result.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, "Submit_SaveContactAndEnquiry");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasError", { msg: err.message }),
            error: err,
          });
        });
      });
    }

  },
};
</script>
<style>
.verifyCodeInput {
  margin-left: 6px;
  width: 217px;
}
</style>